require("./generic-ui-button.scss");

export default class GenericUIButton {
    constructor( options ){
        this.options = {};
        this.options.className = options && options.className || '';
        this.options.onClick = options && options.onClick;

        this._container = document.createElement('div');
        this._container.className = 'mm-generic-ui-button ' + this.options.className;

        this._container.innerHTML = '';

        this.onClick = this.onClick.bind(this);
        this._container.addEventListener('click', this.onClick);
        return this;
    }

    onClick () {
        this.options && this.options.onClick && this.options.onClick();
        return this;
    }

    getContainer () {
        return this._container;
    }

    remove () {
        this._container.parentNode.removeChild(this._container);
    }

    setHTML (html){
        this._container.innerHTML = html;
        return this;
    }
}


// WEBPACK FOOTER //
// src/kiosk/GenericUIButton/index.js